
import { ShoppingList, ShoppingItem } from "@/types";

/**
 * Colonne esplicite per i fetch sui percorsi caldi (lista spesa, articoli, prodotti).
 * Devono restare allineate ai mapper qui sotto: selezionare solo ciò che viene
 * effettivamente consumato evita di scaricare colonne/metadati inutili a ogni fetch.
 */
export const SHOPPING_ITEM_COLUMNS =
  "id, list_id, product_id, quantity, unit, category, checked, position, attributes, created_at, user_id";

export const SHOPPING_LIST_COLUMNS =
  "id, name, user_id, is_primary, rapid_insert, shop_id, background_gradient, created_at, updated_at";

export const USER_PRODUCT_COLUMNS =
  "id, user_id, name, default_quantity, default_unit, photo, barcode, openfoodfacts_id, category_id, created_at, attributes";

export const mapListFromDatabase = (dbList: any): ShoppingList => ({
  id: dbList.id,
  name: dbList.name,
  user_id: dbList.user_id, 
  isPrimary: dbList.is_primary || false,
  is_primary: dbList.is_primary || false,
  rapid_insert: dbList.rapid_insert || false,
  shop_id: dbList.shop_id,
  backgroundGradient: dbList.background_gradient,
  background_gradient: dbList.background_gradient,
  createdAt: new Date(dbList.created_at),
  updatedAt: new Date(dbList.updated_at),
  items: []
});

export const mapItemFromDatabase = (dbItem: any): ShoppingItem => ({
  id: dbItem.id,
  list_id: dbItem.list_id,
  product_id: dbItem.product_id,
  quantity: dbItem.quantity || "1",
  unit: dbItem.unit || "",
  category: dbItem.category || "",
  checked: dbItem.checked || false,
  position: dbItem.position,
  attributes: dbItem.attributes || [],
  created_at: new Date(dbItem.created_at),
  user_id: dbItem.user_id 
});
